import React from 'react';
import { Stack, Card, CardHeader, CardContent, Chip } from '@mui/material';
import {MyTypography, MyIconButton} from '../../common/components';
import {
    Delete as DeleteIcon,
    Description as FileTextIcon,
    AccessTime as ClockIcon,
    CheckCircle,
} from '@mui/icons-material';
import {PROCESSED_STATUS_RECEIVED_FAX, REVIEWED_STATUS_RECEIVED_FAX} from '../constants/fax.consants';

export default function ReceiveFaxListItem({
    status,
    fromNumber,
    dateCreated,
    createdAgo,
    selected,
    onClickFaxItem,
    onDeleteFax,
}) {
    return (
        <Card
            onClick={onClickFaxItem}
            sx={{
                width: '100%',
                mb: 1.5,
                cursor: 'pointer',
                transition: 'all 0.2s',
                border: selected ? 2 : 1,
                borderColor: selected ? 'primary.main' : 'divider',
                bgcolor: selected ? 'primary.50' : 'background.paper',
                '&:hover': {
                    boxShadow: 2,
                    borderColor: 'primary.main',
                },
            }}
        >
            <CardHeader
                avatar={
                    <FileTextIcon color="primary" sx={{ flexShrink: 0 }} />
                }
                title={
                    <Stack direction="row"
                           justifyContent="space-between"
                           alignItems="center">
                        <MyTypography variant="subtitle1" fontWeight="600">
                            From {fromNumber || 'Unknown'}
                        </MyTypography>
                        <Chip
                            icon={status === PROCESSED_STATUS_RECEIVED_FAX ? <CheckCircle /> : <ClockIcon />}
                            color={[PROCESSED_STATUS_RECEIVED_FAX, REVIEWED_STATUS_RECEIVED_FAX].includes(status) ? 'primary' : 'success'}
                            label={status}
                            size="small"
                        />
                    </Stack>
                }
                subheader={
                    <MyTypography variant="body2" color="text.secondary">
                        Received: {dateCreated}
                    </MyTypography>
                }
                sx={{bgcolor: 'background.default'}}
            />
            <CardContent sx={{ p: selected ? 1.5 : 2 }}>
                <Stack direction="row"
                       justifyContent="space-between"
                       alignItems="center">
                    <MyIconButton edge="end"
                                  aria-label="delete"
                                  onClick={onDeleteFax}>
                        <DeleteIcon />
                    </MyIconButton>
                    <MyTypography variant="caption">
                        {createdAgo}
                    </MyTypography>
                </Stack>
            </CardContent>
        </Card>
    );
}